const CLIENT_ENV = process.env.REACT_APP_CLIENT || "core";

export const useClient = () => {
  // Logic is centralized here. If you ever need to change
  // the fallback or add logic, you only do it once.
  return CLIENT_ENV;
};
